export const SELECT_CATEGORY = 'Menu/SELECT_CATEGORY';
export const SELECT_PRODUCT = 'Menu/SELECT_PRODUCT';
